import { render, staticRenderFns } from "./DdtMerce.vue?vue&type=template&id=59230ba0"
import script from "./DdtMerce.vue?vue&type=script&lang=js"
export * from "./DdtMerce.vue?vue&type=script&lang=js"
import style0 from "./DdtMerce.vue?vue&type=style&index=0&id=59230ba0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports